import React, { useState } from "react";
import { Box, Divider, Typography, Modal } from "@mui/material";
import colors from "../styles/colors";
import MoveableImage from "../components/MoveableImage/MoveableImage";
import { contentBoxStyle, imageContainerStyle } from "../styles/commonStyles";

const WebDevelopment: React.FC = () => {
  // Define image paths using PUBLIC_URL
  const hoothoot = `${process.env.PUBLIC_URL}/webPages/hootenanny.jpg`;
  const stadtwerke = `${process.env.PUBLIC_URL}/webPages/stadtwerke.jpg`;
  const ditstribution = `${process.env.PUBLIC_URL}/webPages/w-music.jpg`;
  const baumhaus = `${process.env.PUBLIC_URL}/webPages/bollerott.jpg`;
  return (
    <Box id="content" sx={contentBoxStyle}>
      <Box
        id="text-container"
        sx={{
          maxWidth: "1564px",
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr", // 1 column on extra small screens
            sm: "1fr 1fr", // 2 columns on small screens (1:1 ratio)
            md: "2fr 2fr", // 3 columns on medium screens (1:2 ratio)
          },
          gap: "2rem",
          paddingTop: "10rem",
          paddingBottom: "5rem",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            wordBreak: "break-word",
            borderRadius: "0px 0px 0px 0px",
            boxShadow: "2px 2px 4px rgba(200, 130, 130, 0.50)",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              color: colors.filterColors[0],
              margin: "1rem",
            }}
          >
            Web Development
          </Typography>
        </Box>
        <Box
          sx={{
            color: "white",
            backgroundColor: colors.filterColors[0],
            borderRadius: "50px 0px 50px 0px",
            boxShadow: "2px 2px 4px rgba(200, 130, 130, 0.50)",
          }}
        >
          <Typography variant="body1" margin="1.5rem 1.8rem">
            <p>
            Since starting to work in front-end development, it's become
            something I can't imagine my work life without. I worked on
            developing and styling responsive front-end components based on
            detailed design mockups, ensuring a seamless user experience across
            devices.
            </p>
            <p>
            My role involved creating custom CMS components tailored to each
            project's unique needs, while also diving into the internal
            structure of a custom-built CMS to extend its capabilities and
            implement new features.
            </p>
            <p>
            Throughout the process, I focused on optimizing and refining designs
            for better visual consistency and CMS compatibility. By blending
            creative problem-solving with solid technical skills, I consistently
            delivered components that were not only visually appealing but also
            highly usable, maintainable, and responsive.
            </p>
          </Typography>
        </Box>
      </Box>
      <Box id="image-container" sx={imageContainerStyle}>
        <MoveableImage
          src={ditstribution}
          alt="Preview Image of Website - W-Music Ditstribution"
          headline="Website - W-Music Ditstribution"
          description="Added countFunctionality to the Website - created MapComponent with function 
          - implemented PartnerSection - created different ButtonComponents and effects"
          link="https://www.w-distribution.de/"
        />
        <MoveableImage
          src={hoothoot}
          alt="Preview Image of Website - Hootenanny"
          headline="Website - Hootenanny"
          description="I led the development of this website from concept to deployment. 
          While working with a provided design, I implemented necessary refinements to enhance the user experience. 
          I built the site architecture, integrated functional components, and developed a custom CMS interface that empowered the client to independently manage content, 
          update images, and modify key values across specific sections of the website."
          link="https://www.framus-hootenanny.de/"
        />

        <MoveableImage
          src={stadtwerke}
          alt="Preview Image of Website - Stadtwerke Recklinghausen"
          headline="Website - Stadtwerke Recklinghausen"
          description="A simple website for a local energy company. 
          Fully editable in CMS for the client to manage content, images and other values."
          link="https://www.stadtwerke-re-holding.de/"
        />

        <MoveableImage
          src={baumhaus}
          alt="Preview Image of Website - Bollerott Baumbauten"
          headline="Website - Bollerott Baumbauten"
          description="More complex website for a treehouse manufacturer. 
          Fully editable in CMS for the client to manage content, images and other values. 
          The site includes an Audioplayer, an Image Carousel and parallax effects."
          link="https://www.bollerott-baumbauten.de/"
        />
      </Box>
    </Box>
  );
};

export default WebDevelopment;
